const resources = {
    seeMore: 'See more reviews that mention',
    modalTitle: 'Highly Rated by Customers for'
};

module.exports = function getResource(label) {
    return resources[label];
};
